import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  /* height: calc(100vh - 117px); */
  height: -webkit-fill-available;
  width: 100%;
  color: ${props => props.theme.fontColor};
  > div {
    width: 100%;
  }
  .fc-popover-header {
    color: ${props => props.theme.fontColor};
    background: ${props => props.theme.background};
  }
  .fc-popover-body {
    background: ${props => props.theme.backgroundSecondary};
  }
  .fc-toolbar-chunk,
  .fc-button-group {
    button {
      border-style: none !important;
      border: none !important;
      background-color: ${props => props.theme.button.primary.in} !important;
      &:disabled {
        cursor: not-allowed;
      }
      span {
        color: ${props => props.theme.lightFontColor};
      }
    }
  }
`;
